export const updateData = payload => ({
  type: 'UPDATE_DATA',
  payload,
});
